import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.testimonials';

const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M28.061 17.0612L19.061 26.0612C18.7792 26.343 18.397 26.5013 17.9985 26.5013C17.6 26.5013 17.2178 26.343 16.936 26.0612C16.6542 25.7794 16.4959 25.3972 16.4959 24.9987C16.4959 24.6002 16.6542 24.218 16.936 23.9362L23.3748 17.5H4.99976C4.60193 17.5 4.2204 17.3419 3.9391 17.0606C3.65779 16.7793 3.49976 16.3978 3.49976 16C3.49976 15.6022 3.65779 15.2206 3.9391 14.9393C4.2204 14.658 4.60193 14.5 4.99976 14.5H23.3748L16.9385 8.05998C16.6567 7.77818 16.4984 7.39599 16.4984 6.99747C16.4984 6.59896 16.6567 6.21677 16.9385 5.93497C17.2203 5.65318 17.6025 5.49487 18.001 5.49487C18.3995 5.49487 18.7817 5.65318 19.0635 5.93497L28.0635 14.935C28.2034 15.0745 28.3143 15.2403 28.3899 15.4228C28.4655 15.6054 28.5043 15.801 28.5041 15.9986C28.5038 16.1962 28.4646 16.3918 28.3885 16.5741C28.3125 16.7565 28.2012 16.922 28.061 17.0612Z" fill="currentColor"/></svg>';
const arrowSvgPrev = arrowSvg.replace('<svg ', '<svg style="transform:rotate(180deg)" ');

/**
 * Module Init – parse JSON, build testimonial slides, mount Splide.
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((section) => {
    const sliderEl = section.querySelector('.testimonials__slider.splide');
    const list = section.querySelector('.splide__list');

    if (!sliderEl || !list) return;

    try {
      section.querySelector('script')?.remove();

      const { data } = dJSON.parse(section.data);

      if (!Array.isArray(data) || !data.length) return;

      const fragment = document.createDocumentFragment();
      data.forEach((item) => {
        const {
          name = '', initials = '', position = '', text = '',
        } = item;
        const slide = document.createElement('div');
        slide.className = 'splide__slide';
        slide.innerHTML = /* html */ `
          <div class="testimonials__card">

          <div class="testimonials__card__inner">
              <div class="testimonials__card__inner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="32" viewBox="0 0 44 32" fill="none" aria-hidden="true">
                  <path d="M33.8849 12.7615C34.3724 12.7615 34.8403 12.8342 35.3059 12.9005C35.1551 12.4045 34.9998 11.9001 34.7506 11.4469C34.5014 10.7885 34.1123 10.2178 33.7254 9.64275C33.4018 9.02071 32.8313 8.5996 32.4115 8.06733C31.9721 7.55003 31.3731 7.20588 30.8988 6.77622C30.4331 6.32732 29.8232 6.10287 29.3379 5.78651C28.8307 5.5022 28.3891 5.18798 27.9169 5.03834L26.7386 4.56379L25.7024 4.14268L26.7627 0L28.0678 0.307815C28.4853 0.41042 28.9947 0.530126 29.574 0.673346C30.1664 0.780226 30.7982 1.07308 31.5021 1.34028C32.1973 1.64382 33.0018 1.84903 33.7494 2.33641C34.5014 2.8024 35.3693 3.19145 36.1344 3.81563C36.8755 4.45905 37.7696 5.01697 38.4298 5.83567C39.1512 6.60093 39.8639 7.40468 40.417 8.31957C41.0575 9.19172 41.4925 10.1494 41.9516 11.0963C42.367 12.0433 42.7014 13.0116 42.9747 13.9522C43.4928 15.8375 43.7245 17.6289 43.8141 19.1615C43.8885 20.6963 43.8448 21.9725 43.7529 22.8959C43.7201 23.332 43.6589 23.7552 43.6152 24.0481L43.5606 24.4072L43.5037 24.3944C43.1149 26.1704 42.2198 27.8024 40.922 29.1018C39.6242 30.4011 37.9768 31.3147 36.1702 31.7367C34.3636 32.1587 32.4718 32.072 30.7135 31.4866C28.9552 30.9012 27.4023 29.841 26.2345 28.4287C25.0667 27.0163 24.3316 25.3095 24.1144 23.5058C23.8972 21.702 24.2066 19.875 25.007 18.236C25.8073 16.597 27.0658 15.2131 28.6369 14.2443C30.208 13.2755 32.0275 12.7614 33.8849 12.7615ZM9.838 12.7615C10.3255 12.7615 10.7933 12.8342 11.259 12.9005C11.1081 12.4045 10.9529 11.9001 10.7037 11.4469C10.4545 10.7885 10.0654 10.2178 9.67842 9.64275C9.35488 9.02071 8.78431 8.5996 8.36458 8.06733C7.92518 7.55003 7.32619 7.20588 6.85181 6.77622C6.38617 6.32732 5.77626 6.10287 5.29095 5.78651C4.78377 5.5022 4.34218 5.18798 3.86999 5.03834L2.69169 4.56379L1.65549 4.14268L2.71574 0L4.02083 0.307815C4.43837 0.41042 4.94773 0.530126 5.52704 0.673346C6.11947 0.780226 6.75125 1.07308 7.45517 1.34028C8.14816 1.64596 8.95482 1.84903 9.70247 2.33854C10.4545 2.80454 11.3224 3.19359 12.0875 3.81777C12.8286 4.46119 13.7227 5.0191 14.3829 5.83567C15.1043 6.60093 15.8169 7.40468 16.37 8.31957C17.0105 9.19172 17.4456 10.1494 17.9047 11.0963C18.32 12.0433 18.6545 13.0116 18.9277 13.9522C19.4458 15.8375 19.6776 17.6289 19.7672 19.1615C19.8415 20.6963 19.7978 21.9725 19.706 22.8959C19.6732 23.332 19.612 23.7552 19.5683 24.0481L19.5136 24.4072L19.4568 24.3944C19.068 26.1704 18.1729 27.8024 16.8751 29.1018C15.5773 30.4011 13.9298 31.3147 12.1232 31.7367C10.3167 32.1587 8.42482 32.072 6.66653 31.4866C4.90824 30.9012 3.35537 29.841 2.18756 28.4287C1.01975 27.0163 0.284706 25.3095 0.0674744 23.5058C-0.149761 21.702 0.159683 19.875 0.960018 18.236C1.76035 16.597 3.01886 15.2131 4.58997 14.2443C6.16108 13.2755 7.98058 12.7614 9.838 12.7615Z" fill="currentColor"/>
                </svg>
              </div>
              <p class="testimonials__card__inner__text">${text}</p>
            </div>
            <div class="testimonials__card__author">
              <p class="testimonials__card__author__initials">${initials}</p>
              <div class="testimonials__card__author__info">
                <h2 class="testimonials__card__author__name">${name}</h2>
                <h3 class="testimonials__card__author__position">${position}</h3>
              </div>
            </div>
          </div>
        `;
        fragment.appendChild(slide);
      });
      list.appendChild(fragment);

      // Count number of testimonial slides
      const slideCount = list.children.length;

      // Initialize Splide
      const splide = new Splide(sliderEl, {
        type: 'slide',
        rewind: true,
        perPage: 3,
        perMove: 1,
        gap: 30,
        height: 456,
        arrows: slideCount > 3,
        pagination: slideCount > 3,
        drag: slideCount > 3,
        speed: 400,
        breakpoints: {
          1200: {
            perPage: 2,
            drag: slideCount > 2,
            pagination: slideCount > 2,
            arrows: slideCount > 2,
          },
          768: {
            perPage: 1,
            drag: slideCount > 1,
            pagination: slideCount > 1,
            arrows: slideCount > 1,
            gap: 20,
          },
        },
      });

      // Reposition navigation elements
      const repositionNav = () => {
        const arrows = sliderEl.querySelector('.splide__arrows');
        const pagination = sliderEl.querySelector('.splide__pagination');
        const prevBtn = sliderEl.querySelector('.splide__arrow--prev');
        const nextBtn = sliderEl.querySelector('.splide__arrow--next');
        if (!arrows) return;
        if (pagination && nextBtn) arrows.insertBefore(pagination, nextBtn);
        if (prevBtn) prevBtn.innerHTML = arrowSvgPrev;
        if (nextBtn) nextBtn.innerHTML = arrowSvg;
      };

      // Mount Splide
      splide.mount();
      repositionNav();

      splide.on('resize updated', () => {
        requestAnimationFrame(() => {
          repositionNav();
        });
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
